import React from "react";
import { Field } from "redux-form";
import { Textarea } from "../../../../../itrust_common/components/form";
import TrialContactLensFields from "./TrialContactLensFields";
import ContactLensFulfillment from "../../../../../itrust_common/components/authorised/examFormPartial/refractionContactLens/contactLens/ContactLensFulfillment";

const TrialLensForm = (props) => {
  const { member, orderStatus, currentContactLens, pprops } = props;

  return (
    <div className="col-12 p-5 pb-0">
      <div className="row">
        <div className="col-12 mb-5">
          <TrialContactLensFields
            member={member}
            orderStatus={orderStatus}
            currentContactLens={currentContactLens}
            pprops={pprops}
          />
        </div>

        <div className="col-12 mb-5">
          <Field
            name={`${member}[comment]`}
            component={Textarea}
            placeholder="Comment"
            label="Comment"
            disabled={orderStatus === "finalized"}
            className="form-control"
          />
        </div>

        <ContactLensFulfillment
          member={member}
          orderStatus={orderStatus}
          fulfillment={currentContactLens?.fulfillment}
          pprops={pprops}
        />
      </div>
    </div>
  );
};

export default TrialLensForm;
